import React, { useMemo, useState } from 'react'

import Modal from 'react-bootstrap/Modal'
import { QRCodeSVG } from 'qrcode.react'

import facebookIcon from '../../assets/icons/facebook-filled.svg'
import linkedinIcon from '../../assets/icons/linkedin.svg'
import twitterIcon from '../../assets/icons/twitter-filled.svg'
import qrIcon from '../../assets/icons/scan-qr-code.svg'

import './fundraiserShareModal.scss'

const buildShareText = (campaignTitle) =>
  `Support ${campaignTitle || 'this fundraiser'} on BlockTickets`

const SHARE_CHANNELS = [
  {
    id: 'facebook',
    label: 'Facebook',
    icon: facebookIcon,
    iconClassName: 'fundraiser-share-modal__icon--facebook',
    getUrl: (url) =>
      `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
  },
  {
    id: 'messenger',
    label: 'Messenger',
    iconClassName: 'fundraiser-share-modal__icon--messenger',
    getUrl: (url) =>
      `https://www.facebook.com/dialog/send?link=${encodeURIComponent(url)}&redirect_uri=${encodeURIComponent(url)}`,
    renderIcon: () => (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M12 2C6.477 2 2 6.145 2 11.243c0 2.886 1.447 5.462 3.707 7.17V22l3.236-1.778c.864.24 1.776.37 2.714.37 5.523 0 10-4.145 10-9.243S17.523 2 12 2zm1.033 12.443-2.574-2.743-5.034 2.743 5.544-5.887 2.64 2.743 4.967-2.743-5.543 5.887z"
        />
      </svg>
    ),
  },
  {
    id: 'linkedin',
    label: 'LinkedIn',
    icon: linkedinIcon,
    iconClassName: 'fundraiser-share-modal__icon--linkedin',
    getUrl: (url) =>
      `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
  },
  {
    id: 'nextdoor',
    label: 'Nextdoor',
    iconClassName: 'fundraiser-share-modal__icon--nextdoor',
    getUrl: (url, shareText) =>
      `https://nextdoor.com/sharekit/?source=blocktickets&body=${encodeURIComponent(`${shareText} ${url}`)}`,
    renderIcon: () => (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M5.5 4h13A1.5 1.5 0 0 1 20 5.5v13a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 18.5v-13A1.5 1.5 0 0 1 5.5 4zm2.2 4.1c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm8.6 0c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm-4.3 1.8c-2.2 0-3.5 1.2-3.5 2.8 0 1.7 1.8 2.4 3.5 2.4 1.7 0 3.5-.7 3.5-2.4 0-1.6-1.3-2.8-3.5-2.8z"
        />
      </svg>
    ),
  },
  {
    id: 'whatsapp',
    label: 'WhatsApp',
    iconClassName: 'fundraiser-share-modal__icon--whatsapp',
    getUrl: (url, shareText) =>
      `https://wa.me/?text=${encodeURIComponent(`${shareText} ${url}`)}`,
    renderIcon: () => (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M12.04 2C6.5 2 2.13 6.37 2.13 11.91c0 1.96.52 3.88 1.51 5.57L2 22l4.67-1.61a9.86 9.86 0 0 0 5.37 1.58h.01c5.54 0 9.91-4.37 9.91-9.91C22.95 6.37 18.58 2 12.04 2zm5.9 14.06c-.25.7-1.24 1.36-1.71 1.45-.44.08-1.01.12-1.63-.1-.37-.14-.86-.33-1.49-.65-2.62-1.14-4.33-3.79-4.46-3.97-.13-.18-1.07-1.42-1.07-2.76 0-1.34.7-2 0.95-2.27.25-.27.55-.34.73-.34.18 0 .37 0 .53.01.17.01.4-.07.62.47.23.55.77 1.88.84 2.02.07.14.12.3.02.49-.1.18-.15.29-.3.45-.15.16-.32.36-.45.48-.15.13-.31.27-.13.53.18.27.8 1.32 1.72 2.14 1.18 1.05 2.17 1.38 2.5 1.53.33.16.52.13.71-.08.19-.22.82-.96 1.04-1.29.22-.33.44-.27.73-.16.29.11 1.84.87 2.16 1.03.32.16.53.24.61.37.08.13.08.76-.17 1.46z"
        />
      </svg>
    ),
  },
  {
    id: 'email',
    label: 'Email',
    iconClassName: 'fundraiser-share-modal__icon--email',
    getUrl: (url, shareText) =>
      `mailto:?subject=${encodeURIComponent(shareText)}&body=${encodeURIComponent(`${shareText}\n\n${url}`)}`,
    renderIcon: () => (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M4 4h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2zm0 2v.01L12 13l8-6.99V6H4zm16 12V9l-8 7-8-7v9h16z"
        />
      </svg>
    ),
  },
  {
    id: 'x',
    label: 'X',
    icon: twitterIcon,
    iconClassName: 'fundraiser-share-modal__icon--x',
    getUrl: (url, shareText) =>
      `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(shareText)}`,
  },
  {
    id: 'qr',
    label: 'QR code',
    icon: qrIcon,
    iconClassName: 'fundraiser-share-modal__icon--qr',
    action: 'qr',
  },
]

function ShareChannelIcon({ channel }) {
  if (channel.renderIcon) {
    return channel.renderIcon()
  }

  return <img src={channel.icon} alt="" />
}

export default function FundraiserShareModal({
  show,
  onHide,
  campaignTitle,
  shareUrl,
}) {
  const [copied, setCopied] = useState(false)
  const [showQr, setShowQr] = useState(false)

  const shareText = useMemo(
    () => buildShareText(campaignTitle),
    [campaignTitle]
  )

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl)
    } catch (error) {
      const el = document.createElement('textarea')
      el.value = shareUrl
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
    }

    setCopied(true)
    window.setTimeout(() => setCopied(false), 2000)
  }

  const handleShareChannel = (channel) => {
    if (channel.action === 'qr') {
      setShowQr(true)
      return
    }

    const targetUrl = channel.getUrl(shareUrl, shareText)
    window.open(targetUrl, '_blank', 'noopener,noreferrer')
  }

  const handleClose = () => {
    setShowQr(false)
    setCopied(false)
    onHide()
  }

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      animation={false}
      dialogClassName="fundraiser-share-modal"
      contentClassName="fundraiser-share-modal__content"
    >
      <div className="fundraiser-share-modal__header">
        <h2 className="fundraiser-share-modal__title">Quick share</h2>
        <button
          type="button"
          className="fundraiser-share-modal__close"
          aria-label="Close"
          onClick={handleClose}
        >
          ×
        </button>

        <div className="fundraiser-share-modal__link-field">
          <label className="fundraiser-share-modal__link-label">
            Fundraiser link
          </label>
          <div className="fundraiser-share-modal__link-row">
            <span className="fundraiser-share-modal__link-url">{shareUrl}</span>
            <button
              type="button"
              className="fundraiser-share-modal__copy-btn"
              onClick={handleCopyLink}
            >
              <span
                className="fundraiser-share-modal__copy-icon"
                aria-hidden="true"
              >
                <svg viewBox="0 0 16 16">
                  <rect x="5" y="5" width="9" height="9" rx="1.5" />
                  <path d="M4 11V3.5A1.5 1.5 0 0 1 5.5 2H11" />
                </svg>
              </span>
              {copied ? 'Copied' : 'Copy link'}
            </button>
          </div>
        </div>
      </div>

      <Modal.Body className="fundraiser-share-modal__body">
        {showQr ? (
          <div className="fundraiser-share-modal__qr-panel">
            <button
              type="button"
              className="fundraiser-share-modal__back-btn"
              onClick={() => setShowQr(false)}
            >
              ← Back to share options
            </button>
            <h3 className="fundraiser-share-modal__subtitle">Scan QR code</h3>
            <p className="fundraiser-share-modal__description">
              Scan this code to open the fundraiser on another device.
            </p>
            <div className="fundraiser-share-modal__qr-wrap">
              <QRCodeSVG value={shareUrl} size={200} />
            </div>
          </div>
        ) : (
          <>
            <h3 className="fundraiser-share-modal__subtitle">
              Reach more donors by sharing
            </h3>
            <p className="fundraiser-share-modal__description">
              Share this fundraiser with your network to help reach the goal
              faster.
            </p>

            <div className="fundraiser-share-modal__grid">
              {SHARE_CHANNELS.map((channel) => (
                <button
                  key={channel.id}
                  type="button"
                  className="fundraiser-share-modal__option"
                  onClick={() => handleShareChannel(channel)}
                >
                  <span
                    className={`fundraiser-share-modal__icon ${channel.iconClassName}`}
                  >
                    <ShareChannelIcon channel={channel} />
                  </span>
                  <span>{channel.label}</span>
                </button>
              ))}
            </div>
          </>
        )}
      </Modal.Body>
    </Modal>
  )
}
